module.exports = __webpack_public_path__ + "static/media/tekst-k.1f79747e.mp3";